import { httpClient } from '@/network/clientController'

/** application menu for user
@payload {String} - helper for mock to "fetch" when on company vs particular
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_menu
*/
export const menu = payload => {
	return httpClient({
		method: 'GET',
		url: 'menu',
		params: payload
	})
}

/** application submenu for user used only in mobile
@docs no documentation
*/
export const submenu = payload => {
	return httpClient({
		method: 'GET',
		url: 'menu/submenu',
		params: { isNewApplicationVersion: true }
	})
}
